<template>
  <div class="updataUser-container">
    <div class="head">
      <p>用户信息</p>
    </div>
    <div class="form-container">
      <el-form
        :model="form"
        label-width="100px"
        class="user-form"
        ref="userForm"
      >
        <el-form-item label="头像" prop="avatar">
          <el-upload
            class="avatar-uploader"
            action="#"
            :show-file-list="false"
            :http-request="UploadFile"
            :disabled="true"
          >
            <div class="avatar-container">
              <img :src="form.avatar || Avatar" class="avatar" />
              <!-- <img src="https://sxdatasets.oss-cn-chengdu.aliyuncs.com/2/dataset/Snipaste_2025-06-19_17-36-51.png" class="avatar"> -->
              <div class="avatar-overlay">
                <img :src="camera" class="camera-icon" />
              </div>
            </div>
          </el-upload>
        </el-form-item>
        <el-form-item label="姓名" prop="name" required>
          <el-input
            v-model="form.name"
            disabled
            placeholder="请输入您的姓名"
            maxlength="30"
            show-word-limit
            class="form-input"
          >
          </el-input>
        </el-form-item>

        <el-form-item label="公司名称" prop="company" required>
          <el-input
            v-model="form.company"
            disabled
            placeholder="请输入公司名称"
            maxlength="50"
            show-word-limit
            class="form-input"
          >
          </el-input>
        </el-form-item>

        <el-form-item label="邮箱" prop="email">
          <el-input
            v-model="form.email"
            disabled
            placeholder="请输入邮箱地址"
            class="form-input"
          >
          </el-input>
        </el-form-item>

        <el-form-item label="官网" prop="website">
          <el-input
            v-model="form.website"
            disabled
            placeholder="请输入官网地址"
            class="form-input"
          >
          </el-input>
        </el-form-item>
        <el-form-item label="公钥" prop="public_key">
          <div class="public_key">
            <el-input
              
              v-model="form.public_key"
              disabled
              placeholder="请输入公钥"
              class="form-input public_key"
            >
            </el-input>
            <span class="public_key_text" @click="handlePublicKey">解绑</span>
          </div>
        </el-form-item>

        <el-form-item label="简介" prop="description">
          <el-input
            type="textarea"
            v-model="form.description"
            disabled
            placeholder="请输入简介"
            :rows="6"
            resize="none"
            maxlength="100"
            show-word-limit
            class="form-textarea"
          >
          </el-input>
        </el-form-item>
        <el-form-item >
          <el-button type="primary" @click="submitForm" v-if="$store.state.type!==3">提交</el-button>
          <el-button @click="cancelForm" v-if="$store.state.type!==3">取消</el-button>
        </el-form-item>
      </el-form>
    </div>
    <el-dialog
      title="解绑公钥"
      :visible.sync="dialogVisible"
      width="470px"
      :show-close="false"
    >
      <template slot="title">
        <div class="public_key_dialog_title">
          <p>解绑公钥</p>
        </div>
      </template>
      <div class="public_key_dialog">
        <p>确定要解绑该账户公钥吗？</p>
      </div>
      <template slot="footer">
        <el-button type="primary" @click="deletePublicKey">确定</el-button>
        <el-button @click="dialogVisible = false">取消</el-button>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import { SetUserInfo } from "@/api/user";
import Avatar from "@/assets1/后台/Avatar.png";
import { Message } from "element-ui";
import camera from "@/assets1/后台/camera.png";
import { FileUpLoad } from "@/server/UpLoadFile";
import { DeletePublicKey } from "@/api/user";
export default {
  data() {
    return {
      imageUrl: "",
      text: "",
      form: {
        avatar: this.$route.query.avatar_url,
        name: this.$route.query.username,
        company: this.$route.query.company_name,
        email: this.$route.query.email,
        website: this.$route.query.website,
        description: this.$route.query.bio,
        public_key: this.$route.query.public_key,
      },
      avatarUrl: "",
      dialogVisible: false,
      camera,
      Avatar,
    };
  },
  methods: {
    handlePublicKey() {
        if(this.form.public_key){
        this.dialogVisible = true;
      } else {
        Message({
          message: "请先绑定公钥",
          type: "error",
        });
        return
      }
    },
    async deletePublicKey() {
      try {
        await DeletePublicKey(Number(this.$route.query.id));
        Message({
          message: "解绑成功",
          type: "success",
        });
        this.dialogVisible = false;
        this.form.public_key = "";
        //   this.cancelForm()
      } catch (error) {
        Message({
          message: "解绑失败",
          type: "error",
        });
      }
    },
    async UploadFile(options) {
      console.log(options, "file");
      const res = await FileUpLoad(options.file);
      console.log(res, "res");
      this.form.avatar = res;
      this.avatarUrl = "https://sxdatasets.oss-cn-chengdu.aliyuncs.com/" + res;
    },
    async submitForm() {
      const res = await SetUserInfo({
        username: this.form.name,
        company_name: this.form.company,
        avatar_bucket: "sxdatasets",
        avatar_object: this.form.avatar,
        email: this.form.email,
        website: this.form.website,
        bio: this.form.description,
      });
      Message({
        message: "修改成功",
        type: "success",
      });
      this.avatarUrl = "";
      this.cancelForm();
      console.log(res, "res");
    },
    cancelForm() {
      // this.$refs.userForm.resetFields()
      this.$router.push("/ManageUsers");
    },
  },
};
</script>

<style scoped>
::v-deep .el-dialog {
  border-radius: 10px;
}
.public_key_dialog_title {
  text-align: center;
}
.public_key_dialog {
  text-align: center;
}
.public_key_text {
  margin-left: 20px;
  color: red;
  cursor: pointer;
}
.avatar-item {
  width: 80px;
  height: 80px;
}

.avatar-uploader {
  cursor: pointer;
  position: relative;
  overflow: hidden;
  width: 80px;
  height: 80px;
  border-radius: 50%;
}

.avatar-container {
  position: relative;
  width: 80px;
  height: 80px;
  border-radius: 50%;
  overflow: hidden;
}

.avatar {
  width: 80px;
  height: 80px;
  display: block;
  object-fit: cover;
  border-radius: 50%;
}

.avatar-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(34, 34, 34, 0.4);
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0;
  transition: opacity 0.3s ease;
  border-radius: 50%;
}

.avatar-container:hover .avatar-overlay {
  opacity: 1;
}

.camera-icon {
  width: 24px;
  height: 24px;
  object-fit: contain;
}

.user-form {
  margin-bottom: 40px;
}

.form-input {
  width: 100%;
}

.form-textarea {
  width: 570px;
}
.el-upload__tip {
  font-size: 12px;
  color: #999;
}
.sucess {
  background-color: #0d53ff;
  color: white;
}
.del {
  background-color: #fff;
  color: #666666;
}
.btnList button {
  width: 80px;
  height: 32px;
  border: 1px solid #e9e9e9;
  margin-right: 20px;
  font-size: 14px;
  border-radius: 4px;
}
::v-deep .el-input {
  width: 570px;
  height: 36px;
}
.iconbox {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  color: #e0e0e0;
}
.iconbox p {
  margin-top: 12px;
  font-size: 12px;
  line-height: 17px;
  height: 17px;
}
.el-icon-plus {
  font-size: 20px;
}
::v-deep .el-upload {
  width: 100px;
  height: 100px;
  border: 1px solid #e0e0e0;
  border-radius: 4px;
}

.updataUser-container {
  margin-top: 24px;
  margin-left: 24px;
  font-family: Regular;
}
.head {
  font-size: 24px;
  font-family: Medium;
  margin-bottom: 27px;
}
</style>
